module.exports = __webpack_public_path__ + "static/media/alert.fddaef2b.svg";